import { render, staticRenderFns } from "./TermsOfUseComponent.vue?vue&type=template&id=1f0c0ce8&scoped=true"
var script = {}
import style0 from "./TermsOfUseComponent.vue?vue&type=style&index=0&id=1f0c0ce8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c0ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0c0ce8')) {
      api.createRecord('1f0c0ce8', component.options)
    } else {
      api.reload('1f0c0ce8', component.options)
    }
    module.hot.accept("./TermsOfUseComponent.vue?vue&type=template&id=1f0c0ce8&scoped=true", function () {
      api.rerender('1f0c0ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/terms/TermsOfUseComponent.vue"
export default component.exports